@if (loaderService.loaderVisibility$ | async) {
<div
  class="loader-container position-fixed d-flex align-items-center justify-content-center"
>
  <img
    fetchpriority="high"
    height="70"
    width="65"
    src="images/loader.gif"
    alt="loader"
  />
</div>
}
